"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandLogo = void 0;

require("@albelli/arc-3/lib/core.css");

require("@albelli/arc-3/lib/logo.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var brands = ["albelli", "bonusprint", "fotoknudsen", "minnebanken", "onskefoto", "monalbumphoto"];

var BrandLogo = function BrandLogo(_ref) {
  var vendor = _ref.vendor,
      href = _ref.href,
      brand = _ref.brand,
      white = _ref.white,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["vendor", "href", "brand", "white", "small"]);

  var brandLookup = function brandLookup(vendor) {
    var brand = brands.find(function (i) {
      return vendor.toLowerCase().includes(i);
    });
    return brand ? brand : brands[0];
  };

  if (!!vendor && !brand) brand = brandLookup(vendor);
  var classes = (0, _classnames.default)("arc3-logo-".concat(brand), {
    white: white,
    small: small
  });
  return _react.default.createElement("a", _extends({
    href: href
  }, props), _react.default.createElement("div", {
    className: classes
  }));
};

exports.BrandLogo = BrandLogo;
BrandLogo.propTypes = {
  /** Which logo to set - alternative to brand, will attempt to match vendor to brand */
  vendor: _propTypes.PropTypes.string,

  /** Href to main site for navigation purposes */
  href: _propTypes.PropTypes.string,

  /** Which logo to set */
  brand: _propTypes.PropTypes.oneOf(brands),

  /** Set the colour to white */
  white: _propTypes.PropTypes.bool,

  /** Set the size to small */
  small: _propTypes.PropTypes.bool
};